export default __webpack_public_path__ + "mfa-info.fe890b6b2ae5b756bf363ab08f96f3ec.svg";